<template>
  <div class="thumb-example" v-if="list.length>1">

    <!-- swiper1 -->
    <swiper class="swiper gallery-top" :options="swiperOptionTop" ref="swiperTop"
      @slide-change-transition-start="nowSlide">
      <swiper-slide class="slide1 one_img" v-for="(item, index) in list" :key="index">
        <div class="loupebox" @mousemove="headle($event,item,index)" @mouseleave="leave()"
          @click='imageClicked(loupeImg)'></div>
        <div class="loupe" ref="loupe" :class="isloupeImg?'on':''"></div>
        <img :src="isImageData(item)" class="like_img">
        <!-- <el-image class="like_img" :src="item+'?imageView2/2/w/400'" fit="contain">
          <img slot="error" src="../../../static/images/noimg.svg" class="el-image__inner" style="object-fit: contain;">
        </el-image> -->
      </swiper-slide>
      <div class="list_prev list_prev_card" slot="button-prev"></div>
      <div class="list_next list_next_card" slot="button-next"></div>
    </swiper>
    <div class="loupeImg" :class="isloupeImg?'on':''">
      <img :src="loupeImg" ref="loupeImg">
    </div>
    <!-- @click='isShowBig=false' -->
    <!-- 后面要加缩略和关闭按钮，暂时设置点击图片关闭 -->
    <div class="swiperMask" v-if="isShowBig">
      <div class="bigClose" @click='isShowBig=false'></div>
      <swiper class="swiper gallery-top" v-if="list.length != 1" :options="swiperOptionTop" ref="swiperqq"
        @slide-change-transition-start="nowSlide" style="height:100%;">
        <swiper-slide class="slide1 swiper-no-swiping" v-for="(item, index) in srcUrl" :key="index" style="height:100%">
          <img :src="isImageData(item)" class="like_img">
        </swiper-slide>
        <div class="list_prev list_prev_card" slot="button-prev" @click='isShowBig=true'></div>
        <div class="list_next list_next_card" slot="button-next" @click='isShowBig=true'></div>
      </swiper>
    </div>
    <!-- swiper2 Thumbs -->
    <div class="all_img gallery-thumbs" ref="Thumbs">
      <img :src="isImageData(res)" class="like_img"
        v-for="(res,i) in list" :key='i' @mousemove="small(res,i)">
    </div>
  </div>
  <div v-else class="thumb-example">
    <div class="swiper-slide one_img">
      
      <img :src="isImageData(list[0])" class="like_img">
      <div class="loupebox" @mousemove="headleNOswiper($event)" @mouseleave="leave()" @click='isShowBig=true'></div>
      <div class="loupe" ref="loupe" :class="isloupeImg?'on':''"></div>
    </div>
    <div class="all_img gallery-thumbs">
      <img :src="isImageData(list[0])" class="like_img">
    </div>
    <div class="loupeImg" :class="isloupeImg?'on':''">
      <img :src="isImageData(list[0])" ref="loupeImg">
    </div>
    <div class="swiperMask" v-if="isShowBig">
      <div class="bigClose" @click='isShowBig=false'></div>
      <swiper class="swiper gallery-top" :options="swiperOptionTop" ref="swiperqq"
        @slide-change-transition-start="nowSlide" style="height:100%;">
        <swiper-slide class="slide1 swiper-no-swiping" style="height:100%">
          <img :src="isImageData(list[0])" class="like_img">
        </swiper-slide>
      </swiper>
    </div>
    <!-- <div class="swiperMask" v-if="isShowBig" @click='isShowBig=false'>
      <img :src="list[0]" class="like_img">
    </div> -->
  </div>
</template>
<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import objectFitImages from 'object-fit-images';


export default {
  name: "swiper-example-thumbs-gallery",
  title: "Thumbs gallery with Two-way control",
  components: {
    Swiper,
    SwiperSlide,
  },
  props: {
    list: []
  },
  data() {
    return {
      srcUrl: '',
      isShowBig: false,
      loupeImg: '',
      isloupeImg: false,
      // 放大镜配置
      loupeConfig: {
        ratio: 600/188  // 放大倍率（放大图容器/遮罩尺寸）
      },
      swiperOptionTop: {
        noSwiping: true,
        loopedSlides: 4, // looped slides should be the same
        navigation: {
          nextEl: ".list_next_card",
          prevEl: ".list_prev_card",
        },
      },
      swiperOptionThumbs: {
        loopedSlides: 4, // looped slides should be the same
        spaceBetween: 9,
        slidesPerView: "auto",
        touchRatio: 0.2,
        slideToClickedSlide: true,
      },
    };
  },
  computed: {
    isImageData(){
      return function(url){
        if (!url || typeof url !== 'string') return ''
        const ext = url.split('?')[0].split('.').pop().toLowerCase()
        if(['jpg', 'jpeg', 'png', 'gif', 'webp', 'svg', 'bmp', 'ico'].includes(ext)){
          return url+'?imageView2/2/w/326'
        }else{
          return '../../../static/images/noimg.svg'
        }
        }
        // if (!url || typeof url !== 'string'){
        //   return url
        // }else{
        //   const ext = url.split('?')[0].split('.').pop().toLowerCase()
        //   return ['jpg', 'jpeg', 'png', 'gif', 'webp', 'svg', 'bmp', 'ico'].includes(ext)
        // }
        
      }
    },
  mounted() {
    objectFitImages("img");
    // this.$nextTick(() => {
    //   if (this.list.length > 1) {
    //     const swiperTop = this.$refs.swiperTop.$swiper
    //     const swiperThumbs = this.$refs.swiperThumbs.$swiper
    //     swiperTop.controller.control = swiperThumbs
    //     swiperThumbs.controller.control = swiperTop
    //   }
    // })
  },
  methods: {
    // 点击轮播图获取当前点击的图片进行重新排序并查看大图
    imageClicked(val) {
      this.isShowBig = true;
      this.srcUrl = this.list;
      let imgList = JSON.parse(JSON.stringify(this.srcUrl));
      let _index = imgList.findIndex(item => item == val);
      let afterPicArr = imgList.slice(_index);
      let beforePicArr = imgList.slice(0, _index);
      this.srcUrl = afterPicArr.concat(beforePicArr);
    },
    nowSlide() {
      let i = this.$refs.swiperTop.$swiper.activeIndex
      if (i == 3) {
        this.$refs.Thumbs.getElementsByTagName('img')[0].style.display = 'none'
        this.$refs.Thumbs.getElementsByTagName('img')[1].style.marginLeft = '0'
        this.$refs.Thumbs.getElementsByTagName('img')[4].style.display = 'inline-block'
      } else if (i == 1) {
        this.$refs.Thumbs.getElementsByTagName('img')[0].style.display = 'inline-block'
        this.$refs.Thumbs.getElementsByTagName('img')[1].style.marginLeft = '9px'
        this.$refs.Thumbs.getElementsByTagName('img')[4].style.display = 'none'
      }
    },
    //鼠标离开 隐藏放大镜
    leave(i) {
      this.isloupeImg = false
    },
    // 更新放大镜位置（通用方法，使用 rect.width/height 动态获取尺寸）
    updateLoupe(e, loupeEl, imgEl) {
      const { ratio } = this.loupeConfig;
      // 使用 offsetWidth/offsetHeight 获取当前渲染尺寸（更可靠）
      const size = loupeEl.offsetWidth || 138;
      const offsetX = e.offsetX;
      const offsetY = e.offsetY;
      // 计算放大镜位置（居中于鼠标）
      let left = offsetX - size / 3;
      let top = offsetY - size / 3;
      // 动态计算边界（基于实际容器尺寸）
      const maxLeft = 188;  // 326 - 138
      const maxTop = 188;
      // 边界限制
      left = Math.max(0, Math.min(left, maxLeft));
      top = Math.max(0, Math.min(top, maxTop));
      // 更新放大镜位置
      loupeEl.style.left = left + 'px';
      loupeEl.style.top = top + 'px';
      // 更新放大图片位置
      imgEl.style.left = -ratio * left + 'px';
      imgEl.style.top = -ratio * top + 'px';
    },
    // 无轮播放大镜
    headleNOswiper(e) {
      const loupeEl = this.$refs.loupe;
      const imgEl = this.$refs.loupeImg;
      if (!loupeEl || !imgEl) return;
      this.isloupeImg = true;
      this.updateLoupe(e, loupeEl, imgEl);
    },
    // 轮播放大镜
    headle(e, val, index) {
      const loupeEl = this.$refs.loupe[index];
      const imgEl = this.$refs.loupeImg;
      if (!loupeEl || !imgEl) return;
      this.loupeImg = val;
      this.isloupeImg = true;
      this.updateLoupe(e, loupeEl, imgEl);
    },
    // 鼠标移上小图轮播跳指定页
    small(val, i) {
      this.$refs.swiperTop.$swiper.slideTo(i, 500, false);
      if (this.$refs.Thumbs.getElementsByTagName('img').length > 3) {
        if (i == 3) {
          this.$refs.Thumbs.getElementsByTagName('img')[0].style.display = 'none'
          this.$refs.Thumbs.getElementsByTagName('img')[1].style.marginLeft = '0'
          this.$refs.Thumbs.getElementsByTagName('img')[4].style.display = 'inline-block'
        } else if (i == 1) {
          this.$refs.Thumbs.getElementsByTagName('img')[0].style.display = 'inline-block'
          this.$refs.Thumbs.getElementsByTagName('img')[1].style.marginLeft = '9px'
          this.$refs.Thumbs.getElementsByTagName('img')[4].style.display = 'none'
        }
      }

      //console.log(this.$refs.Thumbs.getElementsByTagName('img')[0].display='none')
      //this.$refs.gallery4.display='inline-block'
    }
  }
};

</script>
<style scoped>
.thumb-example {
  width: 100%;
  /* height: 100%; */
  position: relative;
  margin-bottom: 12px;
}

.swiper-slide {
  background-size: cover;
  background-position: center;
}

.swiper-slide,
.one_img .like_img {
  width: 326px;
  height: 326px;
  object-fit: contain;
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
}

.one_img {
  width: 326px;
  height: 326px;
  position: relative;
}

.one_img .like_img {
  background-color: #f7f7f7;
  border-radius: 6px;
}

.all_img .like_img {
  width: 74px;
  height: 74px;
  background-color: #f7f7f7;
  border-radius: 6px;
  cursor: pointer;
  object-fit: contain;
  margin-left: 9px;
}

.all_img .like_img:first-child {
  margin-left: 0;
}

/* .gallery-top .slide1 {
  width: 326px;
} */

/*.slide-1,
.slide-3 {
  background-image: url("../../static/images/card.jpg");
}
.slide-2,
.slide-4 {
  background-image: url("../../static/images/card2.jpg");
}*/

.gallery-top {
  width: 100%;
  height: 326px;
}

.gallery-thumbs {
  margin: 12px 0 0;
  display: flex;
  overflow: hidden;
}

.gallery-thumbs .slide2 {
  width: 75px;
  height: 75px;
  background-size: cover;
  background-position: center;
}

.gallery-thumbs .swiper-slide-active {
  opacity: 1;
}

.gallery-thumbs .like_img:nth-child(5) {
  display: none;
}

.list_prev,
.list_next {
  width: 32px;
  height: 32px;
  background: rgba(0, 0, 0, 0.6);
  background-repeat: no-repeat;
  background-position: center;
  background-size: 50%;
  border-radius: 4px;
  top: 40%;
  z-index: 10;
  position: absolute;
  cursor: pointer;
}

.swiperMask .list_prev,
.swiperMask .list_next {
  background: none;
  box-shadow: none;
  transition: all 0 ease 0;
  /* background: rgba(0, 0, 0, 0.6); */
  opacity: 1;
}
.swiperMask .list_prev {
  left: 8%;
}
.swiperMask .list_next {
  right: 8%;
}

/* .list_prev {
  background-image: url(../../../static/images/icon/icon_left_awr.png);
} */

.list_next {
  right: 0;
  /* background-image: url(../../../static/images/icon/icon_right_awr.png); */
}

.loupebox {
  width: 326px;
  height: 326px;
  position: absolute;
  cursor: pointer;
  top: 0;
  z-index: 3;
}

.loupe {
  width: 138px;
  height: 138px;
  background-color: rgba(255, 255, 255, 0.6);
  position: absolute;
  top: 0;
  left: 0;
  display: none;
  border-radius: 6px;
}

.loupeImg {
  width: 605px;
  height: 605px;
  background-color: #f0f0f0;
  position: absolute;
  overflow: hidden;
  left: 345px;
  top: 0;
  z-index: 9;
  display: none;
  border-radius: 6px;
}

.loupe.on,
.loupeImg.on {
  display: block;
}

.loupeImg img {
  width: 191%;
  height: 190%;
  position: absolute;
  top: 0;
  left: 0;
  object-fit: contain;
}

.swiperMask {
  position: fixed;
  background-color: rgba(0, 0, 0, 0.4);
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 99;
  /* display: flex;
  align-content: center;
  align-items: center;
  justify-content: center; */
}

.swiperMask img {
  max-width: 80%;
  max-height: 80%;
}
.cardDetails.Release .one_img,
.cardDetails.Release .gallery-thumbs {
  opacity: 1;
}
.bigClose{
  background:#fff url(../../../static/images/icon/icon_close.svg) center no-repeat;
  background-size: 50%;
  z-index: 3;
  width: 48px;
    height: 48px;
    border-radius: 4px;
    position: absolute;
    top:49px;
    right: 80px;
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/swiper/card.vue